import { render } from "./UploadGangSheet.vue?vue&type=template&id=160e6281"
import script from "./UploadGangSheet.vue?vue&type=script&lang=js"
export * from "./UploadGangSheet.vue?vue&type=script&lang=js"

import "./UploadGangSheet.vue?vue&type=style&index=0&id=160e6281&lang=scss"

import exportComponent from "../../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.7.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__